<app-side-menu>
  <div class="b2b-ops-page">
    <div class="page-header">
      <div class="d-flex align-items-center justify-content-between flex-wrap gap-3">
        <div>
          <button type="button" class="btn-back" (click)="navigateBack()"><i class="fas fa-arrow-left"></i></button>
          <h1 class="page-title"><i class="fas fa-chart-pie me-2"></i>Dashboard operacional</h1>
          <p class="page-subtitle" *ngIf="contractNumber">Contrato: {{ contractNumber }} — {{ contractName }}</p>
        </div>
        <app-button
          text="Atualizar"
          color="var(--success-color)"
          height="40px"
          [disabled]="isLoading"
          (buttonClick)="load()">
          <i class="fas fa-sync-alt me-2"></i>
        </app-button>
      </div>
    </div>

    <app-b2b-operational-nav *ngIf="contractId" [contractId]="contractId" active="operacional"></app-b2b-operational-nav>

    <app-loading [show]="isLoading" message="Carregando indicadores..."></app-loading>

    <div *ngIf="!isLoading">
      <div class="row g-3 mb-4">
        <div class="col-6 col-md-3" *ngFor="let st of vehicleStatus">
          <div class="ops-kpi-card" [style.border-left-color]="st.color">
            <div class="ops-kpi-label">{{ st.label }}</div>
            <div class="ops-kpi-value">{{ st.count }}</div>
            <div class="ops-kpi-hint">Status operacional</div>
          </div>
        </div>
      </div>

      <div class="row g-3 mb-4">
        <div class="col-md-4">
          <div class="ops-kpi-card ops-kpi-card--muted">
            <div class="ops-kpi-label">Frota no contrato</div>
            <div class="ops-kpi-value">{{ totalVehicles }}</div>
            <div class="ops-kpi-hint">Veículos (snapshots)</div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="ops-kpi-card ops-kpi-card--muted" role="button" (click)="goTo('manutencoes')">
            <div class="ops-kpi-label">OS / manutenções</div>
            <div class="ops-kpi-value">{{ totalOs }}</div>
            <div class="ops-kpi-hint">{{ openOs }} abertas · {{ scheduledOs }} agendadas</div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="ops-kpi-card ops-kpi-card--muted">
            <div class="ops-kpi-label">A receber (cobranças + competências)</div>
            <div class="ops-kpi-value ops-kpi-value--sm">
              {{ formatMoney((pendingChargesAmount || 0) + (unpaidBillingAmount || 0)) }}
            </div>
            <div class="ops-kpi-hint">Pendências financeiras operacionais</div>
          </div>
        </div>
      </div>

      <div class="b2b-ops-card">
        <h5 class="mb-3">Atalhos operacionais</h5>
        <div class="row g-3">
          <div class="col-md-6 col-lg-4" *ngFor="let link of links">
            <button type="button" class="ops-link-card" (click)="goTo(link.path)">
              <div class="ops-link-icon"><i [class]="link.icon"></i></div>
              <div class="ops-link-body">
                <div class="ops-link-label">{{ link.label }}</div>
                <div class="ops-link-count">{{ link.count }}</div>
                <div class="ops-link-amount" *ngIf="link.amount != null && link.amount > 0">
                  {{ formatMoney(link.amount) }}
                </div>
              </div>
              <i class="fas fa-chevron-right ops-link-arrow"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-side-menu>
